<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title d-flex align-items-center gap-2">
                {{ modalData.title || 'Input' }}
                <span v-if="fileType" class="file-type-badge ms-1">{{ fileType.toUpperCase() }}</span>
            </h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div v-if="fileType == 'avro' || fileType == 'parquet'">
                <div v-if="fileDetails">
                    <OutputParser :compData="fileDetails"/>
                </div>
                <div v-else>
                    <ul class="list-group list-group-sm bg-warning">
                        <li class="list-group-item">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            No preview available
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <div class="file-name-container">
                    <strong>{{ fileName }}</strong>
                </div>
                <CodemirrorEditor :editorId="`${fileType}-${Math.random()}`" v-model="content" :mode="fileType" :refreshOn="true"
                :disabled="true" :readOnly="true" :performLint="false"></CodemirrorEditor>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-primary" :disabled="downloading" @click="handleDownload">
                <div v-if="downloading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    <i class="fa-solid fa-download me-1"></i>
                    Download
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
import OutputParser from "../OutputParser.vue";
export default {
    components: { CodemirrorEditor, OutputParser },
    name: "AgentInputFileViewer",
    data() {
        return {
            content: null,
            fileType: "",
            fileName: "",
            downloading: false,
            copied: false,
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    computed: {
        fileDetails() {
            if (!this.content || !this.fileType) return null;
            return {
                filecontent: this.content,
                filetype: this.fileType,
                filename: this.fileName
            }
        }
    },
    beforeMount() {
        this.content = JSON.parse(JSON.stringify(this.modalData.content)) // deep clone
        this.fileType = JSON.parse(JSON.stringify(this.modalData.file_type)) // deep clone
        this.fileName = this.modalData.file_name || `InputFile.${this.fileType}`
    },
    methods: {
        handleDownload() {
            if (!this.content || !this.content.length) {
                this.error = "Input File not found"
                return;
            }
            this.downloading = true;
            let toastOptions;
            try {
                let file_content = this.fileType == "avro" || this.fileType == "parquet" ? [this.decodeFileContent(this.content)]  : [this.content]

                // Create a Blob from the File content
                const blob = new Blob(file_content, { type: this.fileType == "avro" ? "application/octet-stream" : "text/csv;charset=utf-8;" });
                const url = URL.createObjectURL(blob);

                // Create a temporary link and trigger download
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", this.fileName); // specify the file name
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Download failed:", error);
                toastOptions = {
                    message: "Failed to download file.",
                    type: "error",
                };
                this.$store.dispatch("addToast", toastOptions);
            } finally {
                this.downloading = false;
            }
        },
        decodeFileContent(content) {
            let encodedAvro = JSON.parse(JSON.stringify(content)) // deep clone

            const binaryStr = atob(encodedAvro)
            const bytes = new Uint8Array(binaryStr.length)
            for (let i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i)
            }
            return bytes
        }
    }
}
</script>

<style scoped>
.file-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18em 0.55em;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #4f8ef7;
  background: rgba(79, 142, 247, 0.12);
  border: 1px solid rgba(79, 142, 247, 0.3);
  border-radius: 5px;
  box-shadow: 0 0 4px rgba(79, 142, 247, 0.35);
  text-transform: uppercase;
  line-height: 1;
  flex-shrink: 0;
  transition: box-shadow 0.2s ease;
}

.file-name-container {
  background: rgba(79, 142, 247, 0.12);
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 0.8rem;
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  width: fit-content;
  font-weight: 600;
  color: #4f8ef7;
  margin-bottom: 0.5rem;
  box-shadow: 0 0 4px rgba(79, 142, 247, 0.35);
  border: 1px solid rgba(79, 142, 247, 0.3);
}
</style>